import { FileEntry, Maybe } from '@graphql/generated-graphql';
import React, { useState, useEffect } from 'react';

function formatFileEntry({ file }: { file?: Maybe<FileEntry> }) {
    if (!file) return null;

    if (file?.croppedUrl) return file?.croppedUrl;
    if (file?.url) return file?.url;
    return null;
}

/**
 *
 * @param param0
 */
export function useFileEntry({ file }: { file?: Maybe<FileEntry> }) {
    const [fileUrl, setFileEntry] = useState(() => formatFileEntry({ file }));

    useEffect(() => {
        if (file) {
            setFileEntry(formatFileEntry({ file }));
        } else if (!file) {
            setFileEntry(null);
        }
    }, [file]);

    return fileUrl;
}
